(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["illegal-night-frame-offer"]) return;
  try {
    
  (() => {
    const mutationPattern = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;

    const getRequestUrl = (resource) => {
      if (typeof resource === 'string') return resource;
      if (resource instanceof URL) return resource.href;
      return resource?.url || '';
    };

    const bodyContainsVariant = (body, variantId) => {
      if (!body) return false;

      if (body instanceof FormData || body instanceof URLSearchParams) {
        return Number(body.get('id')) === variantId;
      }

      if (typeof body === 'string') {
        try {
          const parsed = JSON.parse(body);
          if (Number(parsed.id) === variantId) return true;
          return Array.isArray(parsed.items) && parsed.items.some((item) => Number(item.id) === variantId);
        } catch (error) {
          return Number(new URLSearchParams(body).get('id')) === variantId;
        }
      }

      return false;
    };

    if (!window.__illegalNightFrameOfferFetchWrapped) {
      window.__illegalNightFrameOfferFetchWrapped = true;
      const nativeFetch = window.fetch.bind(window);

      window.fetch = async (...args) => {
        const resource = args[0];
        const options = args[1] || {};
        const url = getRequestUrl(resource);
        const match = url.match(mutationPattern);
        const variantId = Number(document.querySelector('illegal-night-frame-offer')?.dataset.variantId || 0);
        const addsFrame = match?.[1] === 'add' && bodyContainsVariant(options.body, variantId);
        const response = await nativeFetch(...args);

        if (match && response.ok) {
          window.dispatchEvent(
            new CustomEvent('illegal-night:cart-mutated', {
              detail: { action: match[1], addsFrame },
            }),
          );
        }

        return response;
      };
    }

    if (customElements.get('illegal-night-frame-offer')) return;

    customElements.define(
      'illegal-night-frame-offer',
      class IllegalNightFrameOffer extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.variantId = Number(this.dataset.variantId);
          this.discountCode = this.dataset.discountCode;
          this.cartJsonUrl = this.dataset.cartJsonUrl || '/cart.js';
          this.dialog = this.querySelector('[role="dialog"]');
          this.closeButton = this.querySelector('.illegal-night-frame-offer__close');
          this.copyButton = this.querySelector('[data-frame-offer-copy]');
          this.applyLink = this.querySelector('[data-frame-offer-apply]');
          this.status = this.querySelector('[data-frame-offer-status]');
          this.lastFocusedElement = null;

          this.querySelectorAll('[data-frame-offer-close]').forEach((button) => {
            button.addEventListener('click', () => this.close());
          });
          this.copyButton?.addEventListener('click', () => this.copyCode());
          this.applyLink?.addEventListener('click', () => this.track('apply'));
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !this.hidden) this.close();
          });
          document.addEventListener(
            'click',
            (event) => {
              if (event.target.closest('#cart-icon-bubble')) this.syncCart(true);
            },
            true,
          );
          window.addEventListener('illegal-night:cart-mutated', (event) => {
            if (event.detail?.addsFrame) {
              this.open();
              this.syncCart(false);
              return;
            }
            this.syncCart(false);
          });

          if (document.body.classList.contains('template-cart')) this.syncCart(true);
        }

        async syncCart(openWhenEligible) {
          try {
            const response = await fetch(this.cartJsonUrl, {
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) return;
            const cart = await response.json();
            const hasFrame = cart.items.some((item) => Number(item.variant_id) === this.variantId);
            const hasDiscount = cart.items.some((item) =>
              item.line_level_discount_allocations?.some(
                (allocation) => allocation.discount_application?.title === this.discountCode,
              ),
            );

            if (!hasFrame || hasDiscount) {
              this.close(false);
              return;
            }

            if (openWhenEligible) this.open();
          } catch (error) {
            return;
          }
        }

        open() {
          if (!this.hidden) return;
          this.lastFocusedElement = document.activeElement;
          this.hidden = false;
          document.body.classList.add('illegal-night-frame-offer-open');
          this.closeButton?.focus({ preventScroll: true });
          this.track('impression');
        }

        close(restoreFocus = true) {
          if (this.hidden) return;
          this.hidden = true;
          document.body.classList.remove('illegal-night-frame-offer-open');
          if (restoreFocus && this.lastFocusedElement instanceof HTMLElement) {
            this.lastFocusedElement.focus({ preventScroll: true });
          }
        }

        async copyCode() {
          const copyLabel = this.copyButton.dataset.copyLabel;
          const copiedLabel = this.copyButton.dataset.copiedLabel;
          const input = document.createElement('input');
          input.value = this.discountCode;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();

          if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(this.discountCode).catch(() => {});
          }

          this.copyButton.textContent = copiedLabel;
          this.status.textContent = copiedLabel;
          this.track('copy');
          window.setTimeout(() => {
            this.copyButton.textContent = copyLabel;
          }, 1800);
        }

        track(action) {
          const eventName = 'illegal_night_frame_offer_' + action;
          const payload = {
            event: eventName,
            discount_code: this.discountCode,
            variant_id: String(this.variantId),
          };
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(payload);
          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish(eventName, payload);
          }
        }
      },
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
